// extracted by mini-css-extract-plugin
export default {"container":"top-banner-container-module__container___LIz5N"};